export enum CreateOrganizationFormField {
  OrganizationName = 'organisationName',
  Domain = 'domain',
  MainAdmin = 'mainAdministrator',
  FirstSubAdmin = 'firstSubAdmin',
  SecondSubAdmin = 'secondSubAdmin',
  CustomLoginEnabled = 'customLoginEnabled',
  Subdomain = 'subdomain',
}

export type CreateOrganizationAdmin = {
  email: string;
  role: 'SUPERADMIN';
};
